// © Microsoft Corporation. All rights reserved.

import { BridgeEventNames, dispatchBridgeEvent } from "../Social.bridge";

import { enums } from "./enums";
import { getExternalURL } from "./urlHelper";
import { isComponentDisabled } from "./themeHelpers";

export default function openGuidelinePage(componentConnector, theme, market, target = "_self") {
    const attributes = [];
    if (isComponentDisabled(theme, "guidelinepage")) {
        if (theme === enums.theme.superappFullpage.name) {
            attributes["onClick"] = (event) => {
                event.preventDefault();
                event.stopPropagation();
                componentConnector.setComponent("guidelinepage", market, theme);
            };
        } else {
            attributes["onClick"] = (event) => {
                event.preventDefault();
                event.stopPropagation();
                dispatchBridgeEvent(BridgeEventNames.openPopup, {component: "guidelinepage", fullScreen: true});
            };
        }
    } else {
        attributes["onClick"] = (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.open(getExternalURL(enums.externalUrls.guidelinePage, market), target);
        };
    }
    return attributes;
}